import { notificationTypes } from '../constants';

export const fetchNotifications = (nextPage) => (dispatch, getState) => {
  const {
    notifications,
    auth: { selectedGoal }
  } = getState();
  const { nextPageToken } = notifications;
  const query = nextPage && nextPageToken ? `?page_token=${nextPageToken}` : '';

  return dispatch({
    type: notificationTypes.FETCH_NOTIFICATIONS,
    endpoint: `v1/move/notifications${query}`,
    method: 'get',
    currentPageToken: nextPage && nextPageToken ? nextPageToken : null,
    selectedGoal
  });
};

export const markNotificationRead = (nid) => (dispatch) =>
  dispatch({
    type: notificationTypes.MARK_NOTIFICATION_READ,
    endpoint: `v1/move/notifications/${nid}/read`,
    method: 'post',
    nid
  });
